import { render, staticRenderFns } from "./companiesTable.vue?vue&type=template&id=5d9c0b04&"
import script from "./companiesTable.vue?vue&type=script&lang=ts&"
export * from "./companiesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports